export const login_mfa_setup_required = {
  title: "Set up multi-factor authentication",
  body: "This sign-in step requires a second factor, but your account does not have one configured yet. Add an authenticator or another method in account settings, then return here to continue.",
  cta: "Open security settings",
};
